import { useEffect, useRef } from "react";

/**
 * For an edit panel that opens above a long list: put the returned `ref` on the
 * panel's wrapper and pass what is being edited (`null` while closed). Each time
 * something is opened, the panel scrolls into view, so a click on a row far
 * down the list does not open it off screen.
 */
export function useScrollIntoViewOnOpen(opened: unknown) {
  const panelRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // jsdom has no scrollIntoView, hence the `?.` on the call.
    if (opened) panelRef.current?.scrollIntoView?.({ block: "nearest" });
  }, [opened]);

  return panelRef;
}
